import { match } from "ts-pattern";

import { AttributeCardCaption } from "@/components/Card/AttributeCard";
import { VStack } from "@/components/Layout";
import { Text } from "@/components/Typography/Text";
import type { ResidenceType } from "@/constants/residenceType";
import { useCommonTranslation } from "@/hooks/useCommonTranslation";

export type AddressData = {
  postalCode?: string | null;
  countryCode?: string | null;
  countryName?: string | null;
  stateProvinceLabel?: string | null;
  city?: string | null;
  streetAddress?: string | null;
  addressLine2?: string | null;
  residenceType?: ResidenceType | null;
};

interface AddressReadOnlyProps {
  data: AddressData;
  emptyMessage?: string;
}

export function AddressReadOnly({
  data,
  emptyMessage = "-",
}: AddressReadOnlyProps) {
  const tc = useCommonTranslation();
  const {
    postalCode,
    countryCode,
    countryName,
    stateProvinceLabel,
    city,
    streetAddress,
    addressLine2,
    residenceType,
  } = data;

  // データがない場合
  if (
    !countryName &&
    !postalCode &&
    !stateProvinceLabel &&
    !city &&
    !streetAddress &&
    !addressLine2 &&
    !residenceType
  ) {
    return (
      <Text variant="label" className="text-muted-foreground">
        {emptyMessage}
      </Text>
    );
  }

  return match(countryCode)
    .with("JP", () => (
      <VStack className="gap-1">
        <AttributeCardCaption>
          {residenceType ? tc(`residenceType.${residenceType}`) : "　"}
        </AttributeCardCaption>
        {postalCode ? (
          <Text variant="label">{`〒${postalCode}`}</Text>
        ) : (
          <Text variant="label">-</Text>
        )}
        <Text variant="label">
          {[countryName, stateProvinceLabel, city, streetAddress]
            .filter(Boolean)
            .join(" ") || "-"}
        </Text>
        {addressLine2 ? <Text variant="label">{addressLine2}</Text> : null}
      </VStack>
    ))
    .otherwise(() => (
      <VStack className="gap-1">
        <AttributeCardCaption>
          {residenceType ? tc(`residenceType.${residenceType}`) : "　"}
        </AttributeCardCaption>
        {streetAddress && <Text variant="label">{streetAddress}</Text>}
        {addressLine2 && <Text variant="label">{addressLine2}</Text>}
        {city && <Text variant="label">{city}</Text>}
        {stateProvinceLabel && (
          <Text variant="label">{stateProvinceLabel}</Text>
        )}
        {postalCode && <Text variant="label">{postalCode}</Text>}
        {countryName && <Text variant="label">{countryName}</Text>}
      </VStack>
    ));
}
